import React from 'react';
import { Heading, Slide } from 'spectacle-ppa';

function htmlSlide ({
  id,
  notes,
  heading,
  bgColor,
  subHeading,
  html,
  slideClass
}) {
  const slideContentClass = slideClass ? ' slide-' + slideClass : '';
  const bgColorOpts = {};
  if (bgColor) {
    bgColorOpts.bgColor = bgColor;
  }
  return (
    <Slide
        id={id}
        key={id}
        {...bgColorOpts}
        notes={notes}
        textColor="white">
      <div className={'slide-content' + slideContentClass}>
        <div
            className="text-formatted">
          { !!heading &&
            <Heading size={3}>
              {heading}
            </Heading>
          }
          { !!subHeading &&
            <Heading size={5}>
              {subHeading}
            </Heading>
          }
          <div
            dangerouslySetInnerHTML={{__html: html}} />
        </div>
      </div>
    </Slide>
  );
}

export default htmlSlide;



// WEBPACK FOOTER //
// ./programs/epsHybridPrimaries/baseSlides/htmlSlide.js